<span class="publish-badge-icon">
  <capra-icon
    data-test="dataset-publish-icon"
    capraTooltip
    icon="icon-publish"
    [tooltipIsDisabled]="!tooltipContent.length"
    [tooltipContent]="tooltipContent"
    tooltipPlacement="bottom"
    tooltipSize="regular"
  ></capra-icon>
</span>
